var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"menu menu--visnet"},[_c('li',[_c('VisnetAttributes',{attrs:{"visnet-hub":_vm.visnetHub}})],1),_c('li',[_c('VisnetNetwork',{attrs:{"visnet-hub":_vm.visnetHub}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }